import { Check, Heart } from "lucide-react";
import useReveal from "../hooks/useReveal";

const VIBE_IMG =
  "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=1400&q=80";

const benefits = [
  "A calm, respectful environment",
  "No intrusive questions or pressure to talk",
  "Smooth, safe driving at all times",
  "A driver who prioritizes your comfort and energy",
];

export const ValueProps = () => {
  const r1 = useReveal();
  const r2 = useReveal();
  return (
    <section
      data-testid="value-props-section"
      className="relative py-24 sm:py-32 px-5 sm:px-8"
    >
      <div className="max-w-7xl mx-auto">
        <div ref={r1} className="reveal max-w-2xl mb-16">
          <span className="font-sans text-xs uppercase tracking-[0.32em] text-[#D4AF37]">
            Protection · Peace · Presence
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-white mt-5 leading-[1.1] tracking-tight">
            This isn't just a ride…
            <br />
            <span className="italic gold-text">
              it's protection, peace, and presence.
            </span>
          </h2>
          <p className="font-sans text-base sm:text-lg text-[#A89FBB] font-light mt-6 leading-relaxed">
            With Royal Rides Queen, every detail is intentional —
            so you can breathe, reset, and feel secure from pickup to
            arrival.
          </p>
        </div>

        {/* Bento asymmetrical grid */}
        <div
          ref={r2}
          className="reveal grid grid-cols-1 md:grid-cols-12 gap-6"
        >
          {/* Image card */}
          <div
            data-testid="vibe-image-card"
            className="md:col-span-5 md:row-span-2 relative overflow-hidden border border-white/5 group min-h-[420px]"
          >
            <img
              src={VIBE_IMG}
              alt="Woman relaxing with city lights at night"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#05030A] via-[#05030A]/30 to-transparent" />
            <div className="absolute bottom-0 left-0 p-7 sm:p-8">
              <Heart
                className="w-5 h-5 text-[#D4AF37] mb-3"
                strokeWidth={1.5}
              />
              <p className="font-serif italic text-xl sm:text-2xl text-white leading-snug max-w-xs">
                "Your space to breathe, reset, and feel secure."
              </p>
            </div>
          </div>

          {/* Benefit cards */}
          {benefits.map((b, i) => (
            <div
              key={b}
              data-testid={`benefit-card-${i}`}
              className="md:col-span-7 group bg-[#0D0814]/80 backdrop-blur-md border border-white/5 p-7 sm:p-8 transition-all duration-300 hover:border-[#D4AF37]/30 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(212,175,55,0.08)]"
              style={{
                gridColumn: i % 2 === 0 ? "span 7 / span 7" : "span 7 / span 7",
              }}
            >
              <div className="flex items-start gap-5">
                <div className="shrink-0 w-10 h-10 border border-[#D4AF37]/40 flex items-center justify-center group-hover:bg-[#D4AF37]/10 transition-colors duration-300">
                  <Check
                    className="w-4 h-4 text-[#D4AF37]"
                    strokeWidth={2}
                  />
                </div>
                <div>
                  <span className="font-sans text-[11px] uppercase tracking-[0.28em] text-[#A89FBB]">
                    No. 0{i + 1}
                  </span>
                  <p className="font-serif text-xl sm:text-2xl text-white mt-2 leading-snug">
                    {b}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
